import { ContentType } from './enums';
import { z } from 'zod';

// Obligations surface on their source and as rollups, never as rows.
export const NON_BROWSABLE_CONTENT_TYPES: ReadonlySet<ContentType> = new Set([ContentType.MESSAGE_EXTRACT]);

// Run records are listed only by a view that names them (the Activity tab); a list that names no types leaves them out.
export const DEFAULT_UNLISTED_CONTENT_TYPES: ReadonlySet<ContentType> = new Set([
  ...NON_BROWSABLE_CONTENT_TYPES,
  ContentType.PROCESS_RUN,
  ContentType.MANUAL_SESSION,
]);

export const browsableContentTypesSchema = z.array(z.nativeEnum(ContentType)).superRefine((contentTypes, ctx) => {
  contentTypes.forEach((contentType, index) => {
    if (NON_BROWSABLE_CONTENT_TYPES.has(contentType)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: [index],
        message: `contentTypes may not include ${contentType}: it is not browsable as a list row`,
      });
    }
  });
});
